import { GlobalCodeCountriesContentModel } from '@csp/csp-common-content-definitions';
import { Iso3166Country } from '@csp/csp-common-model';
import { CountryNamesMapper } from '../../mapper/CountryNamesMapper';
import { CountryNames } from '../CountryNames';

const create = (countries?: Iso3166Country[]): CountryNames => {
  const globalCodeCountries: GlobalCodeCountriesContentModel[] = countries ?? [
    {
      metadata: {},
      code: 'se',
      name: 'Sweden',
    },
    {
      metadata: {},
      code: 'gb',
      name: 'United Kingdom',
    },
    { metadata: {}, code: 'fi', name: 'Finland' },
    {
      metadata: {},
    },
  ];
  return CountryNamesMapper.from({
    global_code: [
      {
        metadata: {},
        title: '[M]title',
        client_application: {
          metadata: {},
          client_value: 'hcp-web',
        },
        countries: globalCodeCountries,
        uid: '[M]uid',
        _content_type_uid: 'global_code',
      },
    ],
  });
};

export const CountryNamesMock = {
  create,
};
